import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'uk',
  months: [
    'січень',
    'лютий',
    'березень',
    'квітень',
    'трав.',
    'червень',
    'липень',
    'серпень',
    'вересень',
    'жовтень',
    'листопад',
    'грудень',
  ],
  monthsShort: [
    'січ.',
    'лют.',
    'бер.',
    'квіт.',
    'травень',
    'черв.',
    'лип.',
    'серп.',
    'вер.',
    'жовт.',
    'лист.',
    'груд.',
  ],
  weekdays: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'],
  weekdaysMin: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  weekdaysShort: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd, D MMM YYYY HH:mm',
    'llll-Y': 'ddd, D MMM HH:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY [р]., HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'дп', pm: 'пп', AM: 'дп', PM: 'пп' },
  past: {
    y: { one: '%s р. тому', few: '%s р. тому', many: '%s р. тому', other: '%s р. тому' },
    M: { one: '%s міс. тому', few: '%s міс. тому', many: '%s міс. тому', other: '%s міс. тому' },
    w: { one: '%s тиж. тому', few: '%s тиж. тому', many: '%s тиж. тому', other: '%s тиж. тому' },
    d: { one: '%s дн. тому', few: '%s дн. тому', many: '%s дн. тому', other: '%s дн. тому' },
    h: { one: '%s год тому', few: '%s год тому', many: '%s год тому', other: '%s год тому' },
    m: { one: '%s хв тому', few: '%s хв тому', many: '%s хв тому', other: '%s хв тому' },
    s: { one: '%s с тому', few: '%s с тому', many: '%s с тому', other: '%s с тому' },
  },
  future: {
    y: { one: 'через %s р.', few: 'через %s р.', many: 'через %s р.', other: 'через %s р.' },
    M: { one: 'через %s міс.', few: 'через %s міс.', many: 'через %s міс.', other: 'через %s міс.' },
    w: { one: 'через %s тиж.', few: 'через %s тиж.', many: 'через %s тиж.', other: 'через %s тиж.' },
    d: { one: 'через %s дн.', few: 'через %s дн.', many: 'через %s дн.', other: 'через %s дн.' },
    h: { one: 'через %s год', few: 'через %s год', many: 'через %s год', other: 'через %s год' },
    m: { one: 'через %s хв', few: 'через %s хв', many: 'через %s хв', other: 'через %s хв' },
    s: { one: 'через %s с', few: 'через %s с', many: 'через %s с', other: 'через %s с' },
  },
  abbr: {
    y: { one: '%s р.', few: '%s р.', many: '%s р.', other: '%s р.' },
    M: { one: '%s міс.', few: '%s міс.', many: '%s міс.', other: '%s міс.' },
    w: { one: '%s тиж.', few: '%s тиж.', many: '%s тиж.', other: '%s тиж.' },
    d: { one: '%s день', few: '%s дні', many: '%s днів', other: '%s дня' },
    h: { one: '%s год', few: '%s год', many: '%s год', other: '%s год' },
    m: { one: '%s хв', few: '%s хв', many: '%s хв', other: '%s хв' },
    s: { one: '%s с', few: '%s с', many: '%s с', other: '%s с' },
  },
  justNow: 'щойно',
  yesterday: 'Учора',
  today: 'Сьогодні',
  tomorrow: 'Завтра',
  weekStart: 1,
};
const localeName: LocaleName = 'uk';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'дп' : 'дп';
    } else {
      return isLowerCase ? 'пп' : 'пп';
    }
  },
};
